import React from 'react';
import styled from '@emotion/styled';
import { DCard } from './detailStyles';

/** 일반 세미나 안내 — 화면 맨 아래, 문장마다 줄바꿈 */
export const GENERAL_NOTICE_LINES: string[] = [
  '이 세미나는 주최 기관이 직접 접수·환불하는 안내용 세미나예요.',
  '명치사 쿠폰·결제·환불 정책이 적용되지 않아요.',
];

const NoticeBox = styled(DCard)`
  background: #fafaf7;
  font-size: 13px;
  line-height: 1.7;
  color: #4b5563;
  word-break: keep-all;
`;

const GeneralNoticeCard: React.FC = () => (
  <NoticeBox aria-label="일반 세미나 안내">
    {GENERAL_NOTICE_LINES.map((line: string) => (
      <div key={line}>· {line}</div>
    ))}
  </NoticeBox>
);

export default GeneralNoticeCard;
